export const formatDateToYYYYMMDD = (date: Date) => {
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
  .toISOString()
  .split("T")[0];
}

export async function stall(stallTime = 3000) {
  await new Promise(resolve => setTimeout(resolve, stallTime));
}

export async function stallAndReturn(condition: boolean, delay: number) {
  return new Promise((resolve) => {
      setTimeout(() => {
        resolve(condition);
      }, delay);
    });
}
